import React from "react";
import { SlLocationPin } from "react-icons/sl";
import { LuPhoneCall, LuMail, LuClock } from "react-icons/lu";

export const contacts = [
  {
    title: "Address",
    icon: <SlLocationPin />,
    text: (
      <a
        href="https://maps.app.goo.gl/MpCtsdpL7wCMUTpp8"
        target="_blank"
        rel="noopener noreferrer"
      >
        900 Jorie Boulevard Suite 101, Oak Brook, IL 60523
      </a>
    ),
  },
  {
    title: "Phone",
    icon: <LuPhoneCall />,
    text: <a href="tel:%20630-881-4679">630-881-4679</a>,
  },
  {
    title: "E-Mail Us",
    icon: <LuMail />,
    text: <a href="mailto:info@qtatax.com">info@qtatax.com</a>,
  },
  {
    title: "Business days",
    icon: <LuClock />,
    text: "Business days: 24/7",
  },
];
